export default function() {
    return {
        dropIns: [],
        coachingBlocks: [],
        upcomingEvent: {},
        activeCoachingblock: null,
        activeCoachingblockId: null,
        activeTimezone: "",
        lastUpdated: null,
        scroll: null,
    }
}
